/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const get_group_room_member_list = createAsyncThunk(
  'RoomVisitor/get_group_room_member_list',
  async (params: any, store: any) => {
    const {h_web_room_id} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/room/get_group_room_member_list',
      {
        room_id: h_web_room_id,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

const initialState: {
  online_member_list: Array<any>
  exit_room_new_user_list: Array<any>
  room_type: number
} = {
  online_member_list: [],
  exit_room_new_user_list: [],
  room_type: 1,
}

export const RoomVisitorSlice = createSlice({
  name: 'RoomVisitor',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_group_room_member_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})

export const useRoomVisitor = () => useSelector((store) => store.RoomVisitor)

export default RoomVisitorSlice.reducer
export const RoomVisitorActions = RoomVisitorSlice.actions
